import React, { FC } from 'react';

import { useI18n, useCurrency } from '~/Hooks';
import { HistoryOrder } from '../../index';
import { RefundButton, RefundStatus, Title, Price, Row } from './styles';
import { Box } from '~Styles';
import { ORDER_STATUS } from '@baemingo/order-status-events/dist/types';
import { combineArticles } from '~Utils/combineArticles';

export interface ReceiptItemsProps {
  order: HistoryOrder;
  handlePrintReceiptCopy: (id: string | undefined) => void;
}

export const ReceiptItems: FC<ReceiptItemsProps> = ({ order, handlePrintReceiptCopy }) => {
  const { i18n } = useI18n();
  const currency = useCurrency();

  const items = combineArticles(
    order.items.map((item) => ({
      id: Math.random().toString(),
      itemId: item.id,
      variations: [],
      categoryId: '', // Not needed here
      vatRate: item.price.percentageVAT,
      title: i18n(item.entry.item.titleLang),
      amount: item.price.amount,
      discount: item.price.discount,
      removedVariations: [],
      description: i18n(item.entry.item.descriptionLang),
    })),
  );

  return (
    <>
      {order?.easyId
        ? order?.items.map(({ id, isRefunded, entry, price }) => (
            <Row key={id}>
              <Title>{i18n(entry.item.titleLang)}</Title>
              {/* If a full refund has been made don't show print button per item */}
              {isRefunded && order.status !== ORDER_STATUS.REFUNDED && (
                <Box
                  marginRight="xs"
                  display="flex"
                  flexWrap="wrap"
                  justifyContent="center"
                  gap="xs">
                  <RefundStatus>{i18n('History.Refunded')}</RefundStatus>
                  <RefundButton onClick={() => handlePrintReceiptCopy(id)}>
                    {i18n('History.PrintRefundReceiptCopy')}
                  </RefundButton>
                </Box>
              )}
              <Price>{currency.format(price.amount - price.discount)}</Price>
            </Row>
          ))
        : items.map((item) => (
            <Row key={item.id}>
              <Title>
                {item.count}x {item.title}
              </Title>
              <Price>{currency.format(item.amount! - item.discount!)}</Price>
            </Row>
          ))}
    </>
  );
};
